// NOTE: While GenericForm is safe to use with any theme, GenericFormContainer must be used
// with a ManualCSS theme.

import React from 'react';
import styled, { css } from 'styled-components';

const FormContainer = styled.div<{ paddingTop?: string }>`
  width: 100%;

  ${({ theme, paddingTop }) => css`
    ${theme.media.xs`
      padding-top: ${paddingTop || theme.ruler[8]}px;
    `};

    ${theme.media.md`
      padding-top: ${paddingTop || theme.ruler[12]}px;
    `};
  `}
`;

export interface GenericFormContainerProps {
  dataQaId?: string;
  paddingTop?: string;
}

const GenericFormContainer: React.FC<
  React.PropsWithChildren<GenericFormContainerProps>
> = ({ dataQaId, paddingTop, children }) => {
  return (
    <FormContainer data-qaid={`${dataQaId}-container`} paddingTop={paddingTop}>
      <form
        id={dataQaId}
        data-qaid={dataQaId}
        onSubmit={(e: any) => {
          e.preventDefault();
        }}
      >
        {children}
      </form>
    </FormContainer>
  );
};

export default GenericFormContainer;
